<template>
  <v-container class="pa-5">
    <v-stepper hide-actions v-model="stepStart" 
      :items="['Kontrola existujícího uživatele', 'Registrace nového uživatele']">
      <template v-slot:[`item.1`]>

        Nejdříve zkontroluj, jestli uživatel v robisu neexistuje, aby se mohla spárovat jeho historie.<br>
        Zobrazí se jen ti uživatelé, kteří nejsou v žádném oddíle.<br>
        Pokud řešíš přestup, musí původní oddíl uživatele nejdříve z oddílu vyloučit.<br> 

        <v-form ref="existingForm" @submit.prevent="registerExistingUser">
          <v-row>
            <!-- Vyhledání v databázi a vyplění polí -->
            <v-col cols="12" md="5">
              <v-autocomplete
              v-model="selectedAccId"
              :items="Accounts"
              :item-title="getFullName"
              item-value="account_id"
              label="Vyber účet"
              :loading="isLoading"
              no-data-text="Neexistují žádní nepřiřazení závodníci."
              clearable
              class="ma-1"
              hide-details
              density="comfortable"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4" class="pb-0" v-show="selectedAccId">
              <v-text-field v-model="account.email" label="Email" :rules="[rules.isValidEmail]" density="comfortable" />
            </v-col>
            <v-col cols="12" md="3" class="pb-0" v-show="selectedAccId">
              <v-text-field event_type_display v-model="account.birth_year" label="Rok narození" type="number" :rules="[rules.year]" density="comfortable" />
            </v-col>
            <v-col cols="12" md="4" class="pb-0" v-show="selectedAccId">
              <v-text-field v-model="account.si_number" type="number" label="Číslo čipu" :rules="[rules.siNumber]" density="comfortable" />
            </v-col>
          
            <v-col cols="12" md="4" class="pb-0" v-show="selectedAccId">
              <v-select v-model="account.gender" :items="sexOptions" label="Pohlaví" :rules="[rules.gender]" density="comfortable"/>
            </v-col>
            <v-col cols="12" md="4" v-if="!isInternational && selectedAccId" class="pb-0">
              <v-row no-gutters>
                <v-text-field v-model="generatedAccountIndexPart" label="" disabled style="max-width:88px;min-width:88px" density="comfortable"/>
                <v-text-field v-model="userAccountIndexPart" label="index" :rules="[rules.userIndexPart]" density="comfortable"/>
              </v-row>
            </v-col>
          </v-row>
                          

          <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
          <v-btn v-if="selectedAccId" :loading="isLoading" class="my-3" type="submit" color="primary" block :disabled="!isAccountFormValid">Přiřadit členství</v-btn>


        </v-form>

      </template>

      <template v-slot:[`item.2`]>

        <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
        <v-alert type="success" v-if="successMessage">{{ successMessage }}</v-alert>
        <h2 class="mb-4">Registrace jednotlivce</h2>
        <v-form @submit.prevent="registerUser">
          <v-row>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field v-model="formData.first_name" label="Křestní jméno" density="comfortable" :rules="[rules.firstName]" />
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field v-model="formData.last_name" label="Příjmení" density="comfortable" :rules="[rules.last_name]" />
            </v-col>

            <v-col cols="12" md="6" class="pb-0">
              <v-text-field v-model="formData.email" label="Email" density="comfortable" :rules="[rules.isValidEmail]" />
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field v-model="formData.si_number" type="number" label="Číslo čipu" density="comfortable" :rules="[rules.siNumber]" />
            </v-col>

            <!-- <v-col cols="12" md="2"><CountrySelect v-model="formData.country" label="Země" /></v-col> -->

            <v-col cols="12" md="4" class="pb-0">
              <v-text-field event_type_display v-model="formData.birth_year" density="comfortable" label="Rok narození" type="number" :rules="[rules.year]" />
            </v-col>
            <v-col cols="12" md="4" class="pb-0">
              <v-select v-model="formData.gender" :items="sexOptions" label="Pohlaví" density="comfortable" :rules="[rules.gender]" />
            </v-col>
            <v-col cols="12" md="4" v-if="!isInternational" class="pb-0">
              <v-row no-gutters>
                <v-text-field v-model="generatedIndexPart" label="" density="comfortable" disabled style="max-width:88px;min-width:88px" />
                <v-text-field v-model="userIndexPart" label="index" density="comfortable" :rules="[rules.userIndexPart]" />
              </v-row>
            </v-col>
          </v-row>

          <v-btn :loading="isLoading" class="my-3" type="submit" color="primary" block :disabled="!isFormValid">Vytvořit účet</v-btn>
        </v-form>
        <h2 class="my-4">Registrace hromadně</h2>
        <span style="color:red">Kvůli velké náročnosti vytváření členů v databázi jde naráz nahrát pouze zhruba 20 záznamů. Prosím, ukládejte členy postupně po tomto počtu.</span>
      
        <v-form @submit.prevent="registerUsers" class="form">
          <v-row class="my-2">
            <v-col cols="auto" class="line-numbers">
              <div v-for="n in linesCount" :key="n" class="line-number">{{ n }}</div>
            </v-col>
            <v-col>
              <v-textarea
                v-if="!isInternational"
                v-model="bulkUserData"
                @input="updateLinesCount"
                label="Příklad: Novotný;Petr;XXX8501;petr.novotny@email.cz;1985;M;25687"
                hint="Zadejte každého uživatele na nový řádek ve formátu: Příjmení;Jméno;index;email;rok narození;pohlaví (M nebo F);číslo SI"
                persistent-hint
                auto-grow
                class="textarea-with-lines"
              />
              <v-textarea
                v-else
                v-model="bulkUserData"
                @input="updateLinesCount"
                label="Example: Novotny;Petr;petr.novotny@email.com;1985;M;25687"
                hint="Every single user should be in separate line in format: Last name;First name;email;birth year;gender (M or F);SI number"
                persistent-hint
                auto-grow
                class="textarea-with-lines"
              />

            </v-col>
          </v-row>
          <v-btn :loading="isLoadingBulk" type="submit" color="primary" block :disabled="!bulkUserData">Provést hromadnou registraci</v-btn>
          <br>
          <v-alert type="error" v-if="errorMessageUsers" :icon="false">
            <div v-for="(error, index) in errorMessageUsers" :key="index">
              {{ error }}
            </div>
          </v-alert>
          <v-alert type="success" v-if="successMessage">{{ successMessage }}</v-alert>
        </v-form>
      </template>
      <v-stepper-actions>
        <template v-slot:next>
          <v-btn color="primary" v-if="stepStart < totalStartSteps" @click="stepStart++">Není tu, musím registrovat >></v-btn>
          <span v-else>&nbsp;</span>
        </template>
        <template v-slot:prev>
          <v-btn variant="plain" v-if="stepStart > 1" @click="stepStart--">Zpět</v-btn>
          <v-btn variant="plain" v-else>&nbsp;</v-btn>
        </template>
      </v-stepper-actions>

    </v-stepper>
  </v-container>
</template>


<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import apiClient from '/api.js';
import { useAuthStore } from '/auth.js';
// import CountrySelect from '@/components/shared/CountrySelect.vue';
// import { countryCodeMap } from "@/utils/countryCodes.js";
import { useSnackbarStore } from '@/stores/snackbarStore';

const props = defineProps({
  club: { type: Object, required: true }
});

const emit = defineEmits(['registered','close']);

const snackbar = useSnackbarStore()

const authStore = useAuthStore(); // Použití Auth Store
const bulkUserData = ref('');
const linesCount = ref(1);

const generatedIndexPart = ref('');
const userIndexPart = ref('');

const isLoading = ref(false);
const isLoadingBulk = ref(false); 

// Zjištění, jestli je uživatel z česka nebo international a podle toho se mu zobrazí typ registrace uživatelů
const isInternational = computed(() => {
  return /^[IJKLMNOPQSTUVWXY]/.test(authStore.index);
});

// Nastavení stepperu
const stepStart = ref(1);
const totalStartSteps = 2;

// --- Logika pro step I ---
const Accounts  = ref([])
const selectedAccId = ref(null)

const account = ref({
  account_id: null,
  first_name: '',
  last_name:  '',
  email:      '',
  si_number:  '',
  birth_year: '',
  gender:     '',
  index:      '',
  lvl:        '',
  country: isInternational.value ? "" : "CZE",
})

// pro výpočet indexu
const generatedAccountIndexPart = ref('')
const userAccountIndexPart      = ref('')
const clubShortCut = computed(() => props.club.club_shortcut)

async function fetchAccounts() {
  if (!clubShortCut.value) return
  isLoading.value = true
  try {
    const resp = await apiClient.get('account/create/', {
      params: { club_shortcut: clubShortCut.value }
    })
    Accounts.value = resp.data
  } finally {
    isLoading.value = false
  }
}


// Získání prvních tří písmen z indexu a předvyplnění pole index
onMounted(() => {
  formData.value.index = clubShortCut.value;
  updateLinesCount();
  fetchAccounts()
});

const getFullName = item => `${item.last_name} ${item.first_name} (${item.account_id})`

const existingForm = ref(null);

// když uživatel vybere účet, předvyplň všechna pole
watch(selectedAccId, async account_id => {
  const u = Accounts.value.find(x => x.account_id === account_id)
  if (!u) return
  account.value.account_id = u.account_id
  account.value.first_name = u.first_name
  account.value.last_name  = u.last_name
  account.value.email      = u.email
  account.value.si_number  = u.si_number
  account.value.birth_year = u.birth_year
  account.value.gender     = u.gender
  // připrav prefix indexu: první tři znaky clubShortCut + poslední dvě z birth_year
  const yy = String(u.birth_year).slice(-2)
  generatedAccountIndexPart.value = clubShortCut.value + yy
  existingForm.value.validate()
})

// po změně gender nebo prefixu znovu sestav full index
watch(
  [
    () => account.value.birth_year,
    () => account.value.gender,
  ],
  ([newYear, newGender]) => {
    const u = Accounts.value.find(x => x.account_id === selectedAccId.value)
    // pokud máme existující index z API, rozděl ho a ukonči
    if (u && u.index) {
      const prefixLen = clubShortCut.value.length + 2
      generatedAccountIndexPart.value = u.index.slice(0, prefixLen)
      userAccountIndexPart.value       = u.index.slice(prefixLen)
      account.value.index              = u.index
      return
    }

    // jinak přepočet prefixu z roku narození
    if (newYear && String(newYear).length === 4) {
      const yy = String(newYear).slice(-2)
      generatedAccountIndexPart.value = clubShortCut.value + yy
    } else {
      generatedAccountIndexPart.value = ''
    }

    // přepočti suffix podle pohlaví (jen pro ne-international)
    if (!isInternational.value && (newGender === 'M' || newGender === 'F')) {
      userAccountIndexPart.value = newGender === 'F' ? '5' : '0'
    } else {
      userAccountIndexPart.value = ''
    }

    // sestav úplný index
    account.value.index = generatedAccountIndexPart.value + userAccountIndexPart.value
  },
  { immediate: true }
)

const isAccountFormValid = computed(() => {
  if (!selectedAccId.value) return false
  return (
    rules.value.isValidEmail(account.value.email) === true &&
    rules.value.siNumber(account.value.si_number) === true &&
    rules.value.year(account.value.birth_year) === true &&
    rules.value.gender(account.value.gender) === true &&
    // u českých indexů validujeme dvě číslice
    (isInternational.value || (/^\d\d$/.test(userAccountIndexPart.value)))
  )
})

// Odeslání formuláře z dat získaných z účtu uživatele - přiřazení role
const registerExistingUser = async () => {

  if (!isAccountFormValid.value) {
    errorMessage.value = 'Některé z polí nejsou správně vyplněné.'
    return
  }

  const payload = {
    ...account.value,
    index: generatedAccountIndexPart.value + userAccountIndexPart.value
  }

  isLoading.value = true;

  try {
    const response = await apiClient.post(`account/create/?account_id=${account.value.account_id}&international=${isInternational.value}&club_id=${props.club.id}`, payload);
    if (response.status === 201) {
      errorMessage.value = '';
    }
    snackbar.showSnackbar("Členství úspěšně přiřazeno. Závodníkovi byl odeslán email.");
    emit('registered')
    emit('close')

  } catch (error) {
    console.error('Chyba při registraci uživatele:', error);
    if (error.response && error.response.data) {
      // Zde předpokládáme, že chybová zpráva je přímo v 'data' jako string nebo jako objekt s klíčem 'error'
      const errorMsg = error.response.data.error || "Účet se nepodařilo vytvořit. Zkontrolujte zadané informace.";
      errorMessage.value = Array.isArray(errorMsg) ? errorMsg.join(', ') : errorMsg;
    } else {
      errorMessage.value = "Účet se nepodařilo přiřadit.";
    }
    successMessage.value = '';
  } finally {
    isLoading.value = false; // Nastavte stav načítání zpět na false
  }
};


// Formulář pro kompletní registraci uživatele

const formData = ref({
  account_id: null,
  email: '',
  first_name: '',
  last_name: '',
  index: '',
  gender: '',
  birth_year: '',
  si_number: '',
  lvl: '',
  country: isInternational.value ? "" : "CZE",
});

const rules = computed(() => ({
  
  isValidEmail: value => (!value || /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) || 'Neplatný email',
  year: value => (value && value >= 1900 && value <= new Date().getFullYear()) || 'Neplatný rok.',
  siNumber: v => (!v || /^\d{4,7}$/.test(v)) || 'Číslo SI musí mít 4–7 cifer',
  firstName: value => (value.trim() !== '') || 'Jméno je povinné pole.',
  last_name: value => (value.trim() !== '') || 'Příjmení je povinné pole.',
  gender: value => (['M', 'F'].includes(value)) || 'Pohlaví je povinné pole.',
  // Použij pravidlo `userIndexPart` jen pokud uživatel **není** mezinárodní
  userIndexPart: value => {
    if (!isInternational.value) {
      return (/^\d\d$/.test(value)) || 'Musí být 2 čísla.';  // Pravidlo pro poslední dvě číslice indexu
    }
    return true; // Při mezinárodní registraci je validní vždy
  }
  }));



// const router = useRouter();
const errorMessage = ref(''); 
const errorMessageUsers = ref('');  // Error message reactive variable

const successMessage = ref(''); 

const sexOptions = [{title: 'Muž', value: 'M'}, {title: 'Žena', value: 'F'}]
// const countryOptions = [{title: 'Česká republika', value: 'CZE'}] 


// Zabránění kliknutí na tlačítka registrovat, pokud chybí některé z polí 
const isFormValid = computed(() => {
  return rules.value.isValidEmail(formData.value.email) === true &&
         rules.value.firstName(formData.value.first_name) === true &&
         rules.value.last_name(formData.value.last_name) === true &&
         rules.value.year(formData.value.birth_year) === true &&
         rules.value.gender(formData.value.gender) === true &&
         rules.value.siNumber(formData.value.si_number) === true &&
         (!isInternational.value || rules.value.userIndexPart(userIndexPart.value) === true);
});




const registerUser = async () => {
  if (!isFormValid.value) {
    errorMessage.value = 'Některé z polí nejsou správně vyplněné.';
    return;
  }

  isLoading.value = true;

  try {
    const response = await apiClient.post(`account/create/?international=${isInternational.value}&club_id=${props.club.id}`, formData.value);
    if (response.status === 201) {
      errorMessage.value = '';
    }
    snackbar.showSnackbar("Účet byl úspěšně vytvořen.");
    emit('registered')
    emit('close')
  } catch (error) {
    console.error('Chyba při registraci uživatele:', error);
    if (error.response && error.response.data) {
      // Zde předpokládáme, že chybová zpráva je přímo v 'data' jako string nebo jako objekt s klíčem 'error'
      const errorMsg = error.response.data.error || "Účet se nepodařilo vytvořit. Zkontrolujte zadané informace.";
      errorMessage.value = Array.isArray(errorMsg) ? errorMsg.join(', ') : errorMsg;
    } else {
      errorMessage.value = "Účet se nepodařilo vytvořit. Zkuste nahrát menší počet záznamů (20 a méně).";
    }
    successMessage.value = '';
  } finally {
    isLoading.value = false; // Nastavte stav načítání zpět na false
  }
};

// Hromadná registrace
const registerUsers = async () => {
  isLoadingBulk.value = true;
  const users = bulkUserData.value.split('\n').filter(line => line.length >= 5).map(line => {
    if (isInternational.value) {
        // Mezinárodní formát (bez indexu)
        const [last_name, first_name, email, birth_year, gender, si_number] = line.split(';');
        return { last_name, first_name, email, birth_year, gender, si_number: si_number || null };
      } else {
        // Český formát (s indexem)
        const [last_name, first_name, index, email, birth_year, gender, si_number] = line.split(';');
        return { last_name, first_name, index, email, birth_year, gender, si_number: si_number || null };
      }
    });
  try {
    const response = await apiClient.post(`account/create_bulk/?international=${isInternational.value}&club_id=${props.club.id}`, users);
    console.log('Všichni uživatelé byli úspěšně zaregistrováni', response.data);
    successMessage.value = 'Všichni uživatelé byli úspěšně vytvořeni.';
    errorMessageUsers.value = '';
    emit('registered');           // rodič obnoví seznam
    emit('close');                // zavře dialog

  } catch (error) {
    console.error('Chyba při registraci uživatele:', error.response.data);
    // Zpracování chybových zpráv
    if (error.response && error.response.data) {
      // Zpracování chyb, kontrola jestli pole 'errors' existuje a má obsah
      if (Array.isArray(error.response.data.errors) && error.response.data.errors.length > 0) {
        errorMessageUsers.value = error.response.data.errors; // Uložte chyby jako pole
      } else {
        errorMessageUsers.value = ["Účty se nepodařilo vytvořit. Nejspíše bude chyba ve vstupních datech."];
      }
      successMessage.value = '';
    } else {
      // V případě, že chybová odpověď neobsahuje očekávanou strukturu
      errorMessageUsers.value = "Účty se nepodařilo vytvořit.";
      successMessage.value = '';
    }
  } finally {
    isLoadingBulk.value = false; // Nastavte stav načítání zpět na false
  }
};

// Watcher pro birth_year, sex a userIndexPart
watch([() => formData.value.birth_year, () => formData.value.gender], ([newYear, newSex]) => {
  if (newYear && newYear.length === 4) {
    const lastTwoDigits = newYear.slice(-2); // Poslední dvě číslice roku
    generatedIndexPart.value = clubShortCut.value + lastTwoDigits;
  }

  let suffix = ''; // Přípona založená na pohlaví
  if (newSex === 'M') {
    suffix = '0';
  } else if (newSex === 'F') {
    suffix = '5';
  }

  userIndexPart.value = suffix;
}, { immediate: true });

watch([() => userIndexPart.value], ([newUserIndexPart]) => {
  formData.value.index = generatedIndexPart.value + newUserIndexPart;
});


// Funkce pro aktualizaci počtu řádků vedle textarey pro hromadnou registraci
const updateLinesCount = () => {
  linesCount.value = bulkUserData.value.split('\n').length;
};

</script>

<style scoped>



.line-numbers {
  text-align: right;
  padding-right: 10px;
  margin-bottom: 34px;
  margin-top:25px;
  color: grey;
  background-color: #f9f9f9; /* Light grey background to distinguish the line numbers */
  border-right: 1px solid #ddd; /* Separator line */
}

.line-number {
  line-height: 1.6; /* Adjust based on your font-size and textarea line-height */
}

.textarea-with-lines {
  min-height: 100px; /* Adjust based on your needs */
  line-height: 1.6; /* Match the line number line height */
}

</style>
